import React, { useState, useEffect, memo } from "react";
import { useDispatch } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, TextField, CircularProgress, Typography } from "@mui/material";
import { SensorName } from "../../../actions/apiActions";
import { fetchDevicesConfigs } from "../../../ducks/devicesConfigsDuck";
import { useSystemConfig } from "../../../hooks/useReduxSelectors";
import { surface } from "../../../../theme/muiTheme";


const RenameLoraSensorModal = memo(({ show, onHide, systemId, displayName, hwId }) => {

  const dispatch = useDispatch();

  const [newName, setNewName] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [saving, setSaving] = useState(false);
  const config = useSystemConfig();

  const modalOpened = () => {
    setNewName("");
  };

  const onChangeHandler = (e, name) => {
    let inputValue = e.target.value;
    setNewName(inputValue);
  };


  const saveName = async () => {
    setSaving(true);

    //format changed parameters to contain only necessary values, push them to formattedState list
    try {
      //save logic here
      const payload = {
        SensorName: newName,
        customerId: (config && config.CUSTOMER_ID) || "",
        deviceId: (config && config.DEVICE_ID) || "",
        hwId: hwId
      };
      await SensorName.post(config.DATA_URL, payload);
      dispatch(fetchDevicesConfigs({
        systemId: systemId,
        systemConfig: config,
        isSensor: true
      }));
      setSaving(false);
      setErrorMsg("");
      onHide();
    } catch (e) {
      e.message ?
        setErrorMsg("Error. " + e.message)
        :
        setErrorMsg("Error. Save was not successful");
      setSaving(false);
    }
  };

  // remove possible error messages when formstate changes meaning when user has given new inputs
  useEffect(() => {
    setErrorMsg("");
  }, [show]);

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth="md"
      fullWidth
      TransitionProps={{ onEnter: modalOpened }}
    >
      <DialogTitle>
        <span>Change name for: </span>
        <span>{`${displayName} `}</span>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ borderTop: `2px solid ${surface.panel}`, px: '80px', pt: 2 }}>
          <TextField
            fullWidth
            onChange={(e) => onChangeHandler(e)}
            type="text"
            placeholder="Enter new name"
            value={newName}
          />
        </Box>
      </DialogContent>
      {saving &&
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress sx={{ color: 'white' }} />
        </Box>
      }
      <Typography sx={{ fontSize: '2rem', textAlign: 'center', color: 'error.main' }}>{errorMsg}</Typography>
      <DialogActions>
        <Button variant="contained" color="primary" size="large" onClick={saveName}>Save</Button>
        <Button variant="outlined" size="large" onClick={onHide}>Close</Button>
      </DialogActions>
    </Dialog>
  );
});

export default RenameLoraSensorModal;